import React from 'react';
import clinicSelectionSx from './ClinicSelection.styles';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Avatar, Card, CardContent, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import api from 'api';
import { actions } from 'store/auth.redux';

const ClinicSelection = () => {
    const theme = useTheme();
    const sx = clinicSelectionSx(theme);
    const dispatch = useDispatch();
    const clinics = useSelector((state) => state.auth.clinics);

    const handleSetClinic = async (clinic_id) => {
        try {
            let result = await api.post('/auth/select-clinic', {
                clinic_id: clinic_id,
            });

            dispatch(actions.setState({ showClinicSelection: result.data.showClinicSelection }));
        } catch (err) {}
    };

    return (
        <Box sx={sx.root}>
            <Box sx={sx.child}>
                <Grid container spacing={4}>
                    {clinics.map((clinic) => (
                        <Grid size={{ xs: 6, md: 4, lg: 3, xl: 3 }} key={clinic.clinic_id}>
                            <Card>
                                <CardContent>
                                    <div>
                                        <Avatar sx={sx.avatar} onClick={() => handleSetClinic(clinic.clinic_id)}>
                                            {clinic.clinic_name
                                                .split(' ')
                                                .slice(0, 3)
                                                .map((part) => part[0].toUpperCase())
                                                .join('')}
                                        </Avatar>
                                    </div>
                                    <div>{clinic.clinic_name}</div>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default ClinicSelection;
